import { LiveAppliedBonus } from "./LiveAppliedBonus";

export class BoostOnePlayerBonus extends LiveAppliedBonus {

  playerId;

  constructor (bonusData = {}) {
    super({
      name: "McDo+",
      value: "boostOnePlayer",
      icon: "/img/bonus-images/mcdo.png",
      description: "+1 point pour le titulaire de ton choix. En voilà un qui a faim de victoire ! 🤤 (excepté le capitaine).",
      timing: "before",
    });
    this.playerId = bonusData.playerId;
  }

  // Le miroir récupère uniquement la méthode "apply" : elle ne doit pas dépendre
  // d'une autre méthode de la classe, sans quoi elle casse quand elle est appelée
  // sur une instance de MirrorBonus.
  apply (team) {
    const player = team.pitchPlayers.find(player => player.playerId === this.playerId);
    if (! player) {
      return;
    }
    player.bonusRating += 1;
  }

  revert (team) {
    const player = team.pitchPlayers.find(player => player.playerId === this.playerId);
    if (! player) {
      return;
    }
    player.bonusRating -= 1;
  }
}